import { Theme, MessageWithCitations as MainMessageWithCitations } from '../../types';

export type { Theme };
export type MessageWithCitations = MainMessageWithCitations;

export const themeColors = {
  light: {
    background: '#FFFFFF',
    text: '#1A1A1A',
    secondaryText: '#666666',
    border: '#E5E5E5',
    messageBackground: {
      user: '#F8F8F8',
      assistant: '#FFFFFF'
    },
    inputBackground: '#FFFFFF',
    sidebarBackground: '#FFFFFF',
    hoverBackground: '#F5F5F5',
    selectedBackground: '#F0F0F0',
    headingText: '#1A1A1A',
    codeBg: '#f5f5f5',
  },
  dark: {
    background: '#0D0D0D',
    text: '#FFFFFF',
    secondaryText: '#888888',
    border: '#2D2D2D',
    messageBackground: {
      user: '#0D0D0D',
      assistant: '#1E1E1E'
    },
    inputBackground: '#1E1E1E',
    sidebarBackground: '#1A1A1A',
    hoverBackground: '#2D2D2D',
    selectedBackground: '#333333',
    headingText: '#FFFFFF',
    codeBg: '#2d2d2d',
  }
};